
import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
  } from "../../helpers/Api/Index";
  
  export const addLab = (data: any) => {
    return postApi(constants.urls.LAB_ADD, data);
  };
  
  export const editLab = (data: any, id: string) => {
    return putApi(constants.urls.LAB_EDIT + "/" + id, data);
 
  };
  
  // export const listLab = (params: string = "") => {
  //   const cityData:any = JSON.parse(localStorage.getItem('loginData') || '')?.city;
  //   return getApi(constants.urls.LAB_LIST +"/"+ cityData, params);
  // };
  export const listLab = (params: string = "") => {
    return getApi(constants.urls.LAB_LIST,params);
  };
  export const deleteLab = (id: string) => {
    return deleteApi(constants.urls.LAB_DELETE + "/" + id);
  };
  export const rollbackLab = (id: string) => {
    return deleteApi(constants.urls.LAB_ROLLBACK + "/" + id);
  };

  export const deleteLabHard = (id: string) => {
    return deleteApi(constants.urls.LAB_DELETE_HARD + "/" + id+"?hard=true");
  };

  export const labDropdown = () => {
    return getApi(constants.urls.LAB_DROPDOWN).then((res:any)=>res.data.map((item:any)=>{
      return {
        id:item.id,
        label: item.patient_id
      }
    }))
  };
  
  export const getByLabId = (id: string) => {
    return getApi(constants.urls.LAB_GETBYID + "/" + id);
  };

  export const labStatus = (id:any, flag:any) => {
    return putApi(constants.urls.LAB_STATUS + "/" + id+"/"+flag, {});
  
  };

  export const labAddDropdown = () => {
    return getApi(constants.urls.LAB_ADD_DROPDOWN).then((res:any)=>res.data.map((item:any)=>{
      return {
        id:item.id,
        label: item.lab_diagnosis_name
      }
    }))
  };
  